const getDefault = () => JSON.parse(localStorage.getItem('userinfo')) || null

const state = {
  islogin: true, // 登录弹窗中当前是登录态还是注册态
  isclose: false, // 登录弹窗开关
  userinfo: getDefault(),
  unread: 0
}

const getters = {
  isLogin: (s) => !!s.userinfo
}

const mutations = {
  SET_USERINFO(state, info) {
    state.userinfo = info
    localStorage.setItem('userinfo', JSON.stringify(info))
  },
  DELETE_USERINFO(state) {
    state.userinfo = null
    localStorage.removeItem('userinfo')
    localStorage.removeItem('luffy_jwt_token')
  },
  CHANGE_ISLOGIN(state, val) { state.islogin = val },
  CLOSE(state, val) { state.isclose = val },
  SET_UNREAD(state, num) { state.unread = num }
}

const actions = {
  setUserInfo({ commit }, info) { commit('SET_USERINFO', info) },
  deleteuserinfo({ commit }) { commit('DELETE_USERINFO') },
  changeislogin({ commit }, val) { commit('CHANGE_ISLOGIN', val) },
  close({ commit }, val) { commit('CLOSE', val) },
  setunread({ commit }, num) { commit('SET_UNREAD', num) }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
